import { TextBox } from '@apply/components';
import { useCustomPaymentName } from '../../../fields/CustomPaymentFields';

interface AccountHolderProps {
    customPaymentId: string;
    required?: boolean;
    validator?: React.ReactNode;
}

export const AccountHolder: React.FC<AccountHolderProps> = ({ customPaymentId, required = false, validator }) => {
    const label = 'Account Holder / Name on Card ';
    const [name, set_name] = useCustomPaymentName(customPaymentId);

    return (
        <>
            <TextBox
                id='customPaymentAccountHolder'
                value={name}
                onChange={(value) => set_name(value)}
                label={label}
                required={required}
                width='100%'
                maxLength={150}
                validator={validator}
            />
        </>
    );
};
